import { render, staticRenderFns } from "./HotAuthor.vue?vue&type=template&id=8ce36712&scoped=true&"
import script from "./HotAuthor.vue?vue&type=script&lang=js&"
export * from "./HotAuthor.vue?vue&type=script&lang=js&"
import style0 from "./HotAuthor.vue?vue&type=style&index=0&id=8ce36712&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ce36712",
  null
  
)

export default component.exports